module.exports = __webpack_public_path__ + "img/analytics_active.4056ee3a.svg";